import React from "react";
import { round, sumBy } from "lodash";
import styled from "styled-components";
import { localize, shorten } from "@backpacker/number";
import HorizontalBarChart from "@charty/horizontal-bar-chart";
import { FontSize, Spacing, content } from "@glossy";
import Rating from "@ui-kit/rating";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";

type HorizontalBarChartProps = React.ComponentProps<typeof HorizontalBarChart>;

export interface SharedWidgetsTermHorizontalBarChartInnerProps {
  total: number;
  gauges: HorizontalBarChartProps["gauges"];
}

const Reviews = styled.div`
  text-align: center;
  color: ${content};
  flex-grow: 0;
  > * {
    line-height: 1em;
  }
`;

const Average = styled.div`
  font-size: 56px;
  margin-bottom: ${Spacing.ExtraSmall};
`;

const Count = styled.div`
  font-size: ${FontSize.Small};
  margin-top: ${Spacing.Medium};
`;

const getAverageRating = (gauges: HorizontalBarChartProps["gauges"]) => {
  const total = sumBy(gauges, "count");
  const ratings = sumBy(gauges, ({ count, id }) => {
    const currentRating = Number(id);
    return count * currentRating;
  });
  return round(ratings / total, 1);
};

export default function SharedWidgetsTermHorizontalBarChartInner({
  total,
  gauges,
}: SharedWidgetsTermHorizontalBarChartInnerProps) {
  const locale = useCurrentUserLocale();
  const averageRating = getAverageRating(gauges);
  return (
    <Reviews>
      <Average>{localize(locale, averageRating)}</Average>
      <Rating locale={locale} value={averageRating} />
      <Count>
        {tr(locale, "TOTAL_REVIEWS", { count: shorten(locale, total) })}
      </Count>
    </Reviews>
  );
}
